import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Header from "../../Header/Header";
import CircularProgress from "@mui/material/CircularProgress";
import * as Icon from "react-feather";
import "./CreditPackage.css";
import { useHistory } from "react-router-dom";

const CreditPackage = () => {
  const url = process.env.REACT_APP_BASEURL;
  const history = useHistory();
  const [creditPackage, setCreditPackage] = useState([]);
  const [msgData, setMsgData] = React.useState(null);
  const [load, setLoad] = useState(false);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newPlan, setNewPlan] = useState({
    planName: "",
    price: "",
    credits: "",
    servicesTitle: "",
    services: [],
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [creating, setCreating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [planToDeleteId, setPlanToDeleteId] = useState(null);

  React.useEffect(() => {
    const tkn = window.sessionStorage.getItem("Token");
    const usr = window.sessionStorage.getItem("User");
    if (!tkn || !usr) {
      history.push("/");
    }
  }, []);

  const handleAddInput = (type) => {
    setCreditPackage((prevState) => {
      return prevState.map((item) => {
        if (item.planName === type) {
          return {
            ...item,
            services: [...item.services, ""],
          };
        }
        return item;
      });
    });
  };

  const handleServicesChange = (value, key, index, innerIndex) => {
    let clonedCreditPackage = [...creditPackage];
    clonedCreditPackage[index][key][innerIndex] = value;
    setCreditPackage(clonedCreditPackage);
  };

  const handleDeleteInput = (planName, index) => {
    setCreditPackage((prevState) => {
      const packageIndex = prevState.findIndex(
        (item) => item.planName === planName
      );
      if (packageIndex !== -1) {
        const updatedServices = prevState[packageIndex].services.filter(
          (_, i) => i !== index
        );
        const updatedPackage = {
          ...prevState[packageIndex],
          services: updatedServices,
        };
        const deleteInputs = [
          ...prevState.slice(0, packageIndex),
          updatedPackage,
          ...prevState.slice(packageIndex + 1),
        ];

        onUpdateCreditPackage({
          field: "services",
          value: JSON.stringify(updatedPackage.services),
          planId: updatedPackage.planId,
        });
        return deleteInputs;
      }
      return prevState;
    });
  };

  const handleGetCreditPackage = () => {
    setLoad(true);
    axios
      .get(`${url}/api/credit/get-credit-packages`, {
        headers: { "x-access-token": window.sessionStorage.getItem("Token") },
      })
      .then((res) => {
        setLoad(false);
        const modifiedData = res?.data?.result?.map((item) => {
          const service = item.services !== "" ? JSON.parse(item.services) : [];
          return {
            ...item,
            services: service,
            servicesTitle: item.servicesTitle || "",
          };
        });
        setCreditPackage(modifiedData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    handleGetCreditPackage();
  }, []);

  const handleUpdateCreditPackage = (plans, key, e, planName) => {
    const value =
      key === "services"
        ? JSON.stringify(
            creditPackage.find((item) => item.planName === planName)?.services
          )
        : e?.target?.innerText;
    const payload = {
      planId: plans,
      field: key,
      value: value,
    };
    onUpdateCreditPackage(payload);
  };

  const onUpdateCreditPackage = (payload) => {
    axios
      .put(`${url}/api/credit/update-credit-package`, payload, {
        headers: { "x-access-token": window.sessionStorage.getItem("Token") },
      })
      .then((res) => {
        setMsgData(
          {
            message: "Package has been updated successfully",
            type: "Success",
          } || null
        );
        setTimeout(() => {
          setMsgData(null);
        }, 1500);
      });
  };

  const showMessage = () => {
    return (
      <div
        className={
          msgData.type === "Success"
            ? "alert alert-success fixed-bottom alert-dismissible fade show"
            : "alert alert-danger fixed-bottom alert-dismissible fade show"
        }
        role="alert"
        style={{ zIndex: "9999" }}
      >
        {msgData.message}
        <button
          type="button"
          className="close"
          onClick={() =>
            document
              .getElementsByClassName("alert")[0]
              ?.classList.remove("show")
          }
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  };

  const handleCreatePlan = () => {
    let errors = {};
    if (!newPlan.planName.trim()) errors.planName = "plan name is required";
    if (!newPlan.credits.trim()) errors.credits = "credits is required";
    if (!newPlan.price.trim()) errors.price = "price is required";
    const hasServices =
      newPlan.services &&
      newPlan.services.length > 0 &&
      newPlan.services.some((s) => s.trim() !== "");
    const hasServicesTitle =
      newPlan.servicesTitle && newPlan.servicesTitle.trim() !== "";
    if (
      (hasServices && !hasServicesTitle) ||
      (!hasServices && hasServicesTitle)
    ) {
      if (!hasServicesTitle)
        errors.servicesTitle =
          "services title is required if services are provided";
      if (!hasServices)
        errors.services = "services are required if services title is provided";
    }
    setFieldErrors(errors);
    if (Object.keys(errors).length > 0) return;
    setCreating(true);
    const payload = {
      ...newPlan,
      services: JSON.stringify(newPlan.services),
    };
    axios
      .post(`${url}/api/credit/create-credit-package`, payload, {
        headers: { "x-access-token": window.sessionStorage.getItem("Token") },
      })
      .then((res) => {
        setMsgData({
          message: "New plan has been created successfully",
          type: "Success",
        });
        setTimeout(() => setMsgData(null), 2000);
        setIsAddingNew(false);
        setNewPlan({
          planName: "",
          price: "",
          credits: "",
          servicesTitle: "",
          services: [],
        });
        handleGetCreditPackage();
      })
      .catch((err) => {
        setMsgData({
          message: err.response?.data?.message || "Failed to create plan",
          type: "Error",
        });
      })
      .finally(() => setCreating(false));
  };

  const handleAddService = () => {
    setNewPlan((prev) => ({
      ...prev,
      services: [...prev.services, ""],
    }));
  };

  const handleServiceChange = (index, value) => {
    setNewPlan((prev) => {
      const newServices = [...prev.services];
      newServices[index] = value;
      return {
        ...prev,
        services: newServices,
      };
    });
  };

  const handleRemoveService = (index) => {
    setNewPlan((prev) => ({
      ...prev,
      services: prev.services.filter((_, i) => i !== index),
    }));
  };

  const handleDeletePlan = (planId) => {
    setPlanToDeleteId(planId);
    setShowDeleteConfirmModal(true);
  };

  const confirmDeletePlan = async () => {
    if (!planToDeleteId) return;

    setShowDeleteConfirmModal(false);
    setDeleting(true);
    console.log(planToDeleteId);
    try {
      await axios.delete(
        `${url}/api/credit/delete-credit-package/${planToDeleteId}`,
        {
          headers: { "x-access-token": window.sessionStorage.getItem("Token") },
        }
      );
      setCreditPackage(
        creditPackage.filter((plan) => plan.planId !== planToDeleteId)
      );
      setMsgData({
        message: "Plan deleted successfully",
        type: "Success",
      });
      setTimeout(() => setMsgData(null), 2000);
    } catch (err) {
      console.error("Failed to delete plan:", err);
      setMsgData({
        message: err.response?.data?.message || "Failed to delete plan",
        type: "Error",
      });
      setTimeout(() => setMsgData(null), 2000);
    } finally {
      setDeleting(false);
      setPlanToDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirmModal(false);
    setPlanToDeleteId(null);
  };

  return (
    <>
      <Header />
      <div className="mx-4" style={{ marginTop: "72px" }}>
        {msgData ? showMessage() : null}
        <div className="d-flex justify-content-between align-items-center py-4">
          <h5 className="section-title">Credit Packages</h5>
        </div>
        {load ? (
          <div className="loader">
            <CircularProgress />
          </div>
        ) : (
          <div className="container">
            <div className="row">
              {/* New Plan Card */}
              <div className="col-md-4 mb-4">
                <div
                  className={`card h-100 plan-card ${
                    isAddingNew ? "editing" : ""
                  }`}
                >
                  <div className="card-body">
                    {isAddingNew ? (
                      <>
                        <div className="form-group mb-4">
                          <label className="form-label">Plan Name</label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <Icon.Tag size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={newPlan.planName}
                              onChange={(e) => {
                                setNewPlan((prev) => ({
                                  ...prev,
                                  planName: e.target.value,
                                }));
                                if (
                                  fieldErrors.planName &&
                                  e.target.value.trim()
                                ) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    planName: undefined,
                                  }));
                                }
                              }}
                              placeholder="Enter Plan Name"
                            />
                          </div>
                          {fieldErrors.planName && (
                            <div
                              style={{
                                color: "#e74c3c",
                                fontSize: "0.85em",
                                marginTop: 4,
                              }}
                            >
                              {fieldErrors.planName}
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-4">
                          <label className="form-label">Price</label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <Icon.DollarSign size={16} />
                            </span>
                            <input
                              type="number"
                              className="form-control"
                              value={newPlan.price}
                              onChange={(e) => {
                                setNewPlan((prev) => ({
                                  ...prev,
                                  price: e.target.value,
                                }));
                                if (
                                  fieldErrors.price &&
                                  e.target.value.trim()
                                ) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    price: undefined,
                                  }));
                                }
                              }}
                              placeholder="Enter Price"
                            />
                          </div>
                          {fieldErrors.price && (
                            <div
                              style={{
                                color: "#e74c3c",
                                fontSize: "0.85em",
                                marginTop: 4,
                              }}
                            >
                              {fieldErrors.price}
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-4">
                          <label className="form-label">Credits</label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <Icon.CreditCard size={16} />
                            </span>
                            <input
                              type="number"
                              className="form-control"
                              value={newPlan.credits}
                              onChange={(e) => {
                                setNewPlan((prev) => ({
                                  ...prev,
                                  credits: e.target.value,
                                }));
                                if (
                                  fieldErrors.credits &&
                                  e.target.value.trim()
                                ) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    credits: undefined,
                                  }));
                                }
                              }}
                              placeholder="Enter Credits"
                            />
                          </div>
                          {fieldErrors.credits && (
                            <div
                              style={{
                                color: "#e74c3c",
                                fontSize: "0.85em",
                                marginTop: 4,
                              }}
                            >
                              {fieldErrors.credits}
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-4">
                          <label className="form-label">Services</label>
                          <div className="services-container">
                            {newPlan.services.map((input, index) => (
                              <div className="service-item" key={index}>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Icon.List size={16} />
                                  </span>
                                  <input
                                    value={input}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => {
                                      handleServiceChange(
                                        index,
                                        e.target.value
                                      );
                                      if (
                                        fieldErrors.services &&
                                        e.target.value.trim()
                                      ) {
                                        setFieldErrors((prev) => ({
                                          ...prev,
                                          services: undefined,
                                        }));
                                      }
                                    }}
                                    placeholder="Enter Service"
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={() => handleRemoveService(index)}
                                  >
                                    <Icon.Trash2 size={16} />
                                  </button>
                                </div>
                              </div>
                            ))}
                            <button
                              className="btn btn-outline-primary w-100 add-service-btn"
                              onClick={handleAddService}
                            >
                              <Icon.Plus size={16} className="me-2" />
                              Add Service
                            </button>
                          </div>
                          {fieldErrors.services && (
                            <div
                              style={{
                                color: "#e74c3c",
                                fontSize: "0.85em",
                                marginTop: 4,
                              }}
                            >
                              {fieldErrors.services}
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-4">
                          <label className="form-label">Services Title</label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <Icon.List size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={newPlan.servicesTitle}
                              onChange={(e) => {
                                setNewPlan((prev) => ({
                                  ...prev,
                                  servicesTitle: e.target.value,
                                }));
                                if (
                                  fieldErrors.servicesTitle &&
                                  e.target.value.trim()
                                ) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    servicesTitle: undefined,
                                  }));
                                }
                              }}
                              placeholder="Enter Services Title"
                            />
                          </div>
                          {fieldErrors.servicesTitle && (
                            <div
                              style={{
                                color: "#e74c3c",
                                fontSize: "0.85em",
                                marginTop: 4,
                              }}
                            >
                              {fieldErrors.servicesTitle}
                            </div>
                          )}
                        </div>
                        <div className="d-flex gap-2 mt-4">
                          <button
                            className="btn btn-light flex-grow-1"
                            onClick={() => {
                              setIsAddingNew(false);
                              setNewPlan({
                                planName: "",
                                price: "",
                                credits: "",
                                servicesTitle: "",
                                services: [],
                              });
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary flex-grow-1"
                            onClick={handleCreatePlan}
                            disabled={creating}
                          >
                            {creating ? (
                              <CircularProgress
                                size={18}
                                color="inherit"
                                style={{ marginRight: 8 }}
                              />
                            ) : null}
                            Create Plan
                          </button>
                        </div>
                      </>
                    ) : (
                      <div
                        className="add-plan-placeholder"
                        onClick={() => setIsAddingNew(true)}
                      >
                        <div className="icon-wrapper">
                          <Icon.PlusCircle size={48} />
                        </div>
                        <h5>Add New Plan</h5>
                        <p className="text-muted">
                          Click to create a new credit package
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Existing Plan Cards */}
              {creditPackage?.map((plan) => (
                <div className="col-md-4 mb-4" key={plan.planId}>
                  <div className="card h-100 plan-card">
                    <div className="card-header">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-0">{plan.planName}</h5>
                        <button
                          className="btn btn-sm"
                          style={{ color: "white" }}
                          onClick={() => handleDeletePlan(plan.planId)}
                          disabled={deleting}
                        >
                          <Icon.Trash2 size={16} />
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="plan-detail mb-4">
                        <div className="detail-label">
                          <Icon.DollarSign size={16} className="me-2" />
                          Price
                        </div>
                        <div
                          contentEditable
                          suppressContentEditableWarning={true}
                          className="detail-value"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.target.blur();
                              handleUpdateCreditPackage(
                                plan.planId,
                                "price",
                                e
                              );
                            }
                          }}
                        >
                          {plan.price}
                        </div>
                      </div>
                      <div className="plan-detail mb-4">
                        <div className="detail-label">
                          <Icon.CreditCard size={16} className="me-2" />
                          Credits
                        </div>
                        <div
                          contentEditable
                          suppressContentEditableWarning={true}
                          className="detail-value"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.target.blur();
                              handleUpdateCreditPackage(
                                plan.planId,
                                "credits",
                                e
                              );
                            }
                          }}
                        >
                          {plan.credits}
                        </div>
                      </div>
                      <div className="plan-detail">
                        <div className="detail-label">
                          <Icon.List size={16} className="me-2" />
                          Services
                        </div>
                        <div className="services-list">
                          {plan.services?.map((service, index) => (
                            <div className="service-item" key={index}>
                              <div className="input-group">
                                <input
                                  value={service}
                                  type="text"
                                  className="form-control"
                                  onChange={(e) => {
                                    handleServicesChange(
                                      e.target.value,
                                      "services",
                                      creditPackage.findIndex(
                                        (p) => p.planId === plan.planId
                                      ),
                                      index,
                                      plan.planName
                                    );
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.target.blur();
                                      handleUpdateCreditPackage(
                                        plan.planId,
                                        "services",
                                        e,
                                        plan.planName
                                      );
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() =>
                                    handleDeleteInput(plan.planName, index)
                                  }
                                >
                                  <Icon.Trash2 size={16} />
                                </button>
                              </div>
                            </div>
                          ))}
                          <button
                            className="btn btn-outline-primary w-100 add-service-btn"
                            onClick={() => handleAddInput(plan.planName)}
                          >
                            <Icon.Plus size={16} className="me-2" />
                            Add Service
                          </button>
                        </div>
                      </div>
                      <div className="plan-detail mb-4">
                        <div className="detail-label">
                          <Icon.List size={16} className="me-2" />
                          Services Title
                        </div>
                        <div
                          contentEditable
                          suppressContentEditableWarning={true}
                          className="detail-value"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.target.blur();
                              handleUpdateCreditPackage(
                                plan.planId,
                                "servicesTitle",
                                e
                              );
                            }
                          }}
                        >
                          {plan.servicesTitle
                            ? plan.servicesTitle
                            : "This package includes:"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Confirmation Modal */}
      {showDeleteConfirmModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1050,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
              textAlign: "center",
              minWidth: "500px",
            }}
          >
            <h5 style={{ marginBottom: "15px" }}>Confirm Deletion</h5>
            <p className="d-flex">Are you sure you want to delete this plan?</p>
            <div
              className="d-flex justify-content-end"
              style={{ marginTop: "20px" }}
            >
              <button
                className="btn btn-secondary me-2"
                onClick={cancelDelete}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={confirmDeletePlan}
                disabled={deleting}
              >
                {deleting ? (
                  <CircularProgress
                    size={18}
                    color="inherit"
                    style={{ marginRight: 8 }}
                  />
                ) : null}
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreditPackage;
